import { useEffect, useRef, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function usePoll(path, ms = 10000) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await api.get(path);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(e);
    }
  }, [path]);
  useEffect(() => {
    load();
    const id = setInterval(load, ms);
    return () => clearInterval(id);
  }, [load, ms]);
  return { data, error, reload: load };
}

export function beep(kind = "info") {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const tones = kind === "siren" ? [880, 660, 880, 660] : kind === "error" ? [440, 330] : [740];
    tones.forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.frequency.value = f;
      o.connect(g);
      g.connect(ctx.destination);
      g.gain.setValueAtTime(0.08, ctx.currentTime + i * 0.25);
      o.start(ctx.currentTime + i * 0.25);
      o.stop(ctx.currentTime + i * 0.25 + 0.2);
    });
  } catch (e) {
    /* audio unavailable */
  }
}

export function useNotifications(user) {
  const since = useRef(new Date().toISOString());
  useEffect(() => {
    if (!user) return undefined;
    const prefs = user.notify || {};
    if (prefs.browser && "Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }
    const tick = async () => {
      try {
        const { data } = await api.get(`/notifications?since=${encodeURIComponent(since.current)}`);
        if (!data.length) return;
        since.current = data[0].at;
        data.slice(0, 4).reverse().forEach((n) => {
          const fn = n.level === "error" ? toast.error : n.level === "warning" ? toast.warning : toast;
          fn(n.title, { description: n.body });
          if (prefs.browser && "Notification" in window && Notification.permission === "granted") {
            new Notification(n.title, { body: n.body });
          }
          if (prefs.sound) beep(n.kind === "kill_warning" ? "siren" : n.level);
        });
      } catch (e) {
        /* ignore */
      }
    };
    const id = setInterval(tick, 10000);
    return () => clearInterval(id);
  }, [user]);
}
